import { render } from "./ModalTypePapers.vue?vue&type=template&id=6590a624&scoped=true"
import script from "./ModalTypePapers.vue?vue&type=script&lang=js"
export * from "./ModalTypePapers.vue?vue&type=script&lang=js"

import "./ModalTypePapers.vue?vue&type=style&index=0&id=6590a624&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6590a624"]])

export default __exports__